import React from "react";
import styles from "./FileDrop.module.scss"; // Import css modules stylesheet as styles
import { getIcon } from "../../icon/icon";
import CustomizedSnackbars from "../snackbar/Snackbar";
import { Box, Grid, Typography } from "@material-ui/core";
import { withTranslation } from "react-i18next";

class FileDrop extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      highlight: false,
      snackbarOpen: false,
      fileTooLargeSnackbarOpen: false,
      fileImages: {},

      fileTooLargeText: this.props.t('common.file-size-too-large-maximum-is-50mb'),
      fileBadFormatText: this.props.t('common.could-not-find-content-to-upload')
    };
    this.fileInputRef = React.createRef();

    this.openFileDialog = this.openFileDialog.bind(this);
    this.onFilesAdded = this.onFilesAdded.bind(this);
    this.onDragStart = this.onDragStart.bind(this);
    this.onDragOver = this.onDragOver.bind(this);
    this.onDragEnter = this.onDragEnter.bind(this);
    this.onDragLeave = this.onDragLeave.bind(this);
    this.onDrop = this.onDrop.bind(this);
  }

  openFileDialog() {
    if (this.props.disabled) return;
    this.fileInputRef.current.click();
  }

  handleFilesAdded(filesList) {
    if (this.props.disabled) return;

    if (filesList.length > 0 && this.props.onFilesAdded) {
      if (!this.props.multiple) {
        if (this.checkFile(filesList[0])) {
          this.props.onFilesAdded([filesList[0]]);
        } else {
          this.setState({ snackbarOpen: true });
        }
      } else {
        filesList.forEach(file => {
          if (this.checkFile(filesList[0])) {
            const fileReader = new FileReader()

            fileReader.onload = (event) => {
              const fileImages = Object.assign({}, this.state.fileImages);
              fileImages[file.name] = event.target.result
              this.setState({
                fileImages: fileImages
              });
            }
            fileReader.readAsDataURL(file)
          } else {
            this.setState({ snackbarOpen: true });
            return
          }
        });
        this.props.onFilesAdded(filesList);
      }
    } else {
      this.setState({ snackbarOpen: true });
    }
  }

  onFilesAdded(event) {
    const files = event.currentTarget.files
    this.handleFilesAdded(Object.values(files))
  }

  onDragStart(evt) {
    evt.dataTransfer.clearData();
    evt.preventDefault();
    evt.stopPropagation();
  }

  onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
  }

  onDragEnter(evt) {
    evt.preventDefault();
    evt.stopPropagation();

    if (this.props.disabled) return;
    this.dragCounter++;
    if (evt.dataTransfer.items && evt.dataTransfer.items.length > 0) {
      this.setState({ highlight: true });
    }
  }

  onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();

    this.dragCounter--;
    if (this.dragCounter === 0) {
      this.setState({ highlight: false });
    }
  }

  onDrop(event) {
    event.preventDefault();
    event.stopPropagation();
    const files = Object.values(event.dataTransfer.files);
    this.handleFilesAdded(files);
    this.setState({ highlight: false });
    this.dragCounter = 0;
  }

  componentDidMount() {
    this.dragCounter = 0;
  }

  checkFile(file) {
    if (file) {
      if (file.size > 50000000) {
        this.setState({ fileTooLargeSnackbarOpen: true })
        return false
      }

      return true
    }

    return false
  }

  handleClose() {
    this.setState({ snackbarOpen: false })
  }

  render() {
    return (
      <div className={styles.dropzone + " " + (this.state.highlight ? styles.highlight : "")}
        style={{ cursor: this.props.disabled ? "default" : "pointer" }}
      >
        <CustomizedSnackbars handleClose={() => { this.setState({ snackbarOpen: false }) }} open={this.state.fileTooLargeSnackbarOpen} variant="error" message={this.state.fileTooLargeText} />
        <CustomizedSnackbars handleClose={() => { this.setState({ snackbarOpen: false }) }} open={this.state.snackbarOpen} variant="error" message={this.state.fileBadFormatText} />

        <div
          className={styles.innerZone}
          onDragStart={this.onDragStart}
          onDragOver={this.onDragOver}
          onDragEnter={this.onDragEnter}
          onDragLeave={this.onDragLeave}
          onDrop={this.onDrop}
          onClick={this.openFileDialog}
        >
          <input
            ref={this.fileInputRef}
            className={styles.fileInput}
            type="file"
            multiple={this.props.multiple}
            onChange={this.onFilesAdded}
          />


          {this.props.file == null || this.props.file.length == 0 ?
            <Box className={styles.item}>
              {getIcon("upload.svg", styles.icon)}
              <span className={styles.textStyle}>
                {this.props.message}
              </span>
            </Box> :
            <Box className={styles.gridContent}>
              {this.props.multiple ?
                <Typography align="center" >{this.props.t('common.files-to-be-uploaded', {count: this.props.file.length})}</Typography> :
                null
              }
              <Grid container>
                {
                  this.props.file.map((file, index) => {
                    return (
                      <Grid item xs={2}>
                        <Box className={styles.item}>
                          <img className={styles.icon} src={this.state.fileImages[file.name] != null ? this.state.fileImages[file.name] : ""} onError={e => {
                            const image = getIcon("checkmark-circle.svg");
                            e.target.src = image.props.src
                          }} />
                          <Typography align="center" className={styles.textStyle} >
                            {
                              file == null
                                ? this.props.message
                                : file.name
                            }
                          </Typography>
                        </Box>

                      </Grid>
                    )
                  })
                }
              </Grid>
            </Box>
          }
        </div>
      </div >
    );
  }
}
export default withTranslation()(FileDrop);
